export const Icons = {
    'home': 'ph:house-duotone',
    'tenants': 'ph:suitcase-duotone',
    'tenant': 'ph:suitcase-duotone',
    'vehicles': 'ph:car-duotone',
    'managers': 'ph:user-gear-duotone',
    'orders': 'ph:clipboard-text-duotone',
    'settings': 'ph:gear-duotone',
    'clients': 'ph:identification-card-duotone',
    'agents': 'ph:users-three-duotone',
    'add': 'ph:plus-bold',
    'edit': 'ph:note-pencil-bold',
    'dark': 'ph:moon-stars-duotone',
    'light': 'ph:sun-duotone',
    'successCircle': 'ph:check-circle-duotone',
    'failCircle': 'ph:x-circle-duotone',
    'warningCircle': 'ph:warning-circle-duotone',
    'search': 'ph:magnifying-glass-duotone',
    'go': 'ph:arrow-circle-right-light',
    'cancel': 'ph:x-circle-light',
    'clientDetails': 'ph:address-book',
    'clientLicense': 'ph:identification-card',
    'clientInsurance': 'ph:keyboard',
    'back': 'ph:arrow-left-bold',
    'user': 'ph:user-circle-duotone',
    'created_by_user': 'ph:user-circle-duotone',
    'updated_by_user': 'ph:user-circle-duotone',
    'out': 'ph:sign-out-bold',
    'forward': 'ph:arrow-right-bold',
    'image': 'ion:image-outline',
    'images': 'ion:images-outline',
    'files': 'ph:files-duotone',
    'download': 'ph:download-simple',
    'upload': 'ph:upload-simple',
    'billing': 'ph:notebook-duotone',
    'delete': 'ph:trash-duotone',
    'disable': 'ph:pause-circle-duotone',
    'enable': 'ph:play-circle-duotone',
    'reservations': 'ph:calendar-blank-duotone',
    'list': 'ph:list-light',
    'cards': 'ph:grid-four-light',
    'language': 'ph:translate-duotone',
    'point': 'ph:storefront-duotone',
    'location': 'ph:map-pin-duotone',
    'visit': 'ph:clipboard-text-duotone',
    'objective': 'ph:list-checks-duotone',
    'clone': 'clarity:clone-line',
    'venue': 'ph:storefront-duotone',
    'area': 'ph:crop-duotone',
    'guideline': 'ph:list-checks-duotone',
    'booking': 'ph:calendar-check-duotone',
    'talent': 'mdi:artist-outline',
    'inbox': 'solar:inbox-in-line-duotone',
    'calendar': 'ph:calendar-blank-duotone',
    'blackout': 'ph:calendar-x-duotone',
}

export type IconNames = keyof typeof Icons